import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.less';

export interface InputProps
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  addonAfter?: React.ReactNode;
  addonBefore?: React.ReactNode;
  errorText?: string;
  color?: 'black';
  hideBg?: Boolean;
}

const Input = React.forwardRef(function InputComponent(
  { addonAfter, addonBefore, type, className, errorText, color, hideBg, onChange, ...rest }: InputProps,
  forwardedRef: React.ForwardedRef<any>
) {
  return (
    <div
      className={classNames(styles.box, [{ [styles.black]: color === 'black', [className as string]: !!className }])}
    >
      <div className={styles.inputbox} style={hideBg ? { backgroundColor: '#ffffff00' } : {}}>
        {addonBefore && <div className={styles.before}>{addonBefore}</div>}
        <input
          {...rest}
          type={type}
          ref={forwardedRef}
          className={classNames(styles.input)}
          onChange={e => {
            let value = e.target.value;
            if (type === 'tel' && onChange) {
              if (!/^\d*$/.test(e.target.value)) {
                value = e.target.value.replace(/[^\d]/g, '');
              }

              onChange(value as any);
            }
          }}
        />
        {addonAfter && <div className={styles.after}>{addonAfter}</div>}
      </div>
      <div className={classNames(styles.errors, { [styles.show]: !!errorText })}>{errorText}</div>
    </div>
  );
});

export default Input;
